import { token } from "./../utils/token.utils";
import { getRequest, postRequest, updateRequest } from "./api.service";
import { API_URL } from "../utils/constants";
import { ICommon, PartnerData, PartnerResponse } from "../pages/reviews/types";
import { createAdmin } from "../pages/admin/types";
import showToast from "../utils/show.toast";

export enum Levels {
  MERCHANT = 3,
  ROOTADMIN = 1,
  FINANCE = 2,
}

export enum AdminStatusType {
  ACTIVE = "active",
  SUSPENDED = "suspended",
  DEACTIVATED = "deactivated",
}

export enum IAdminLevel {
  ROOTADMIN = "rootAdmin",
  MERCHANT = "merchant",
  FINANCE = "finance",
}

export interface Admin {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  status: AdminStatusType;
  dateOfBirth: string;
  level: string;
}

export interface AdminResponse extends ICommon {
  result: {
    admins: Admin[];
  };
}

export interface SingleAdmin extends ICommon {
  result: Admin;
}

interface ChangeAdminStatus {
  id: number;
  url: string;
}

export const listPartnersByStatus = async (
  status: string
): Promise<PartnerResponse> => {
  const data = await getRequest<PartnerResponse>(
    `${API_URL}/merchants/partners/by-status?status=${status}`
  );
  return data;
};

export const getPartnerDetails = async (
  endpoint: string
): Promise<PartnerData> => {
  const data = await getRequest<PartnerData>(`${API_URL}/${endpoint}`);
  return data;
};

export const getTotalPartnersByStatus = async (): Promise<any> => {
  const data = await getRequest<{ result: { users: number } }>(
    `${API_URL}/merchants/partners/status-counts`
  );
  console.log(data);
  return data.result;
};

export const listAdminByLevels = async (
  adminLevel: string | null,
  offset: number
): Promise<AdminResponse> => {
  const data = await getRequest<AdminResponse>(
    `${API_URL}/admin/all-admin?level=${adminLevel}`
  );

  // localhost:3000/admin/all-admin?level=4&offset=1
  return data;
};

export const adminStatus = async (
  status: AdminStatusType
): Promise<AdminResponse> => {
  const data = await getRequest<AdminResponse>(
    `${API_URL}/admin/all-admin?status=${status}`
  );
  return data;
};

export const adminDetails = async (id: number): Promise<SingleAdmin> => {
  try {
    console.log(`Fetching admin details for ID: ${id}`);
    const request = await getRequest<SingleAdmin>(`${API_URL}/admin/${id}`);
    return request;
  } catch (error) {
    throw showToast("Error Fetching Datas!", false);
  }
};

export const createAdminRecord = async (admin: createAdmin): Promise<any> => {
  const data = await postRequest<{ id: string }>(
    `${API_URL}/auth/register-admin`,
    {
      ...admin,
    }
  );

  return { success: true, data };
};
